import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TBr, IDeps } from './models';
import { Br as Component } from './br';
import styles from './styles/styles.css';

export const Br = createWidget<IDeps, TBr>({
    styles,
})(Component);
